module.exports = __webpack_public_path__ + "static/media/reddit-alien.9253ff0b.svg";